import Store from 'redux/store';
import {
  FETCH_SHIPPING,
  FETCH_SHIPPING_FAIL,
  FETCH_SHIPPING_SUCCESS,
  FETCH_CART_SHIPPING,
  FETCH_CART_SHIPPING_SUCCESS,
  FETCH_CART_SHIPPING_FAIL,
  UPDATE_CART_SHIPPING,
  UPDATE_CART_SHIPPING_FAIL,
  UPDATE_CART_SHIPPING_SUCCESS,
} from 'redux/Reducers/Shipping/ShippingReducer';
import { cloudloyalty } from '../clients';

const getShippingSuccess = (data) => {
  Store.dispatch({
    type: FETCH_SHIPPING_SUCCESS,
    payload: {
      data,
    },
  });
};

/* eslint-disable */
const FetchShipping = async (
  User,
  finallyCallback = () => {},
  { zipCode, productSku }
) => {
  Store.dispatch({ type: FETCH_SHIPPING, payload: { cep: zipCode } });
  const manipulateModel = ({ data }, address, _zipCode) => {
    const { streetType, street, district, city, state } = address.data;

    let DataEntrega = data.deliveryDate.split('T')[0];

    DataEntrega = DataEntrega.split('-');

    const model = {
      code: _zipCode,
      address: `${streetType} ${street}`,
      district: `${district}`,
      city: `${city} - ${state}`,
      shippingValue: data.total,
      shippingValueCash: data.totalCash,
      deliveryForeCastDate: `${DataEntrega[2]}/${DataEntrega[1]}/${DataEntrega[0]}`,
    };

    getShippingSuccess(model);
  };
  const handleSuccess = (response, _zipCode) => {
    if (!_zipCode || _zipCode === '00000000') {
      Store.dispatch({
        type: FETCH_SHIPPING_FAIL,
        error: {
          response: {
            errors: [],
            message: "CEP inválido!"
          },
          status: 500
        },
      });
      finallyCallback();
      return;
    }
    cloudloyalty(User)
      .get(`v1/addresses/${_zipCode}`)
      .then((responseAddress) => {
        manipulateModel(response, responseAddress, _zipCode);
      })
      .catch((e) => {
        Store.dispatch({
          type: FETCH_SHIPPING_FAIL,
          error: e,
        });
      })
      .finally(() => {
        finallyCallback();
      });
  };

  cloudloyalty(User)
    .get(`/v2/products/sku/${productSku}/shipping/${zipCode}`)
    .then((response) => {
      handleSuccess(response, zipCode);
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_SHIPPING_FAIL,
        error: e,
      });
    });
};

export default FetchShipping;

export const FetchCartShipping = async (
  User,
  finallyCallback = () => {},
  { zipCode }
) => {
  Store.dispatch({ type: FETCH_CART_SHIPPING });
  if (!zipCode || zipCode === '00000000') {
    Store.dispatch({
      type: FETCH_CART_SHIPPING_FAIL,
      error: {
        response: {
          data: {
            errors: [],
            message: "CEP inválido!"
          }
        },
        status: 500
      },
    });
    finallyCallback();
    return;
  }
  cloudloyalty(User)
    .get(`/v1/carts/me/shipping/rates/${zipCode}`)
    .then((response) => {
      Store.dispatch({
        type: FETCH_CART_SHIPPING_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_CART_SHIPPING_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchCartAddressShipping = async (
  User,
  finallyCallback = () => {},
  { zipCode }
) => {
  Store.dispatch({ type: FETCH_SHIPPING, payload: { cep: zipCode } });
  if (!zipCode || zipCode === '00000000') {
    Store.dispatch({
      type: FETCH_SHIPPING_FAIL,
      error: {
        response: {
          data: {
            errors: [],
            message: "CEP inválido!"
          }
        },
        status: 500
      },
    });
    finallyCallback();
    return;
  }
  cloudloyalty(User)
    .get(`v1/addresses/${zipCode}`)
    .then((response) => {

      const { streetType, street, district, city, state } = response.data;

      const model = {
        code: zipCode,
        address: `${streetType} ${street}`,
        district: `${district}`,
        city: `${city} - ${state}`,
      };

      Store.dispatch({
        type: FETCH_SHIPPING_SUCCESS,
        payload: {
          data: model,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_SHIPPING_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export const PutCartShipping = async (
  User,
  finallyCallback = () => {},
  payload = {}
) => {
  Store.dispatch({ type: UPDATE_CART_SHIPPING });
  cloudloyalty(User)
    .put('/v1/carts/me/shipping', payload)
    .then((response) => {
      Store.dispatch({
        type: UPDATE_CART_SHIPPING_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: UPDATE_CART_SHIPPING_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};
